// extracted by mini-css-extract-plugin
export default {"card":"simulation_card__3NiEt","cardImage":"simulation_cardImage__+Seig","cardContent":"simulation_cardContent__0huGr","cardButton":"simulation_cardButton__a4qPy"};